import { TableRow } from '@material-ui/core'
import { isNil } from 'lodash'
import React from 'react'
import { VersionCostCalculator } from '../../../calculators/costs/VersionCostCalculator'
import { TableTitleCell } from '../../common/TableTitleCell'
import { TableValueCell } from '../../common/TableValueCell'
import { getCumulativeValues, getComparativePaybackPeriod } from '../costs-util'

export type PaybackVersionValues = {
  buildingYear: number
  values: number[]
}

type Props = {
  title: string
  versions: VersionCostCalculator[]
  selectedContainerName: string | null
  containerIdsToNames: Record<string, string>
  comparisonVersion: VersionCostCalculator
}

export function PaybackTableRow({
  title,
  versions,
  selectedContainerName,
  containerIdsToNames,
  comparisonVersion,
}: Props): React.ReactElement {
  const getVersionValues = (
    version: VersionCostCalculator,
  ): PaybackVersionValues => ({
    buildingYear: version.getBuildingYear(),
    values: getCumulativeValues(
      version,
      selectedContainerName,
      containerIdsToNames,
    ),
  })

  const formatResult = (paybackResult: number | null) =>
    isNil(paybackResult) ? '-' : paybackResult.toString()

  return (
    <TableRow>
      <TableTitleCell title={title} />
      {versions.map((version) =>
        version.getId() === comparisonVersion.getId() ? (
          <TableValueCell
            key={`profitability-header-${version.getId()}`}
            value="-"
          />
        ) : (
          <TableValueCell
            key={`profitability-header-${version.getId()}`}
            value={formatResult(
              getComparativePaybackPeriod(
                getVersionValues(comparisonVersion),
                getVersionValues(version),
              ),
            )}
          />
        ),
      )}
    </TableRow>
  )
}
